import Heading from '../app/design/Heading'
import Paragraph from '../app/design/Paragraph'

type Props = {
    src?: string
    title?: string
    subtitle?: string
}

export const CalendarEmptyState = ({ src, title, subtitle }: Props) => {
    return (
        <div className="flex h-full flex-col items-center justify-center gap-4">
            {!!src && <img src={src} alt="" />}

            <div className="flex flex-col items-center justify-center gap-2">
                {!!title && (
                    <Heading size="xs" className="text-gray-700">
                        {title}
                    </Heading>
                )}
                {!!subtitle && <Paragraph className="text-gray-600">{subtitle}</Paragraph>}
            </div>
        </div>
    )
}
